var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbar"},[_c('ul',_vm._l((_vm.tabList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.onTab(item)}}},[_vm._v(_vm._s(item.tabName))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }